export const JOB_POSITION = 'job_position';

export default {
  [JOB_POSITION]: {
    es: '/unete/:slug',
    en: '/join-us/:slug',
    fr: '/rejoignez/:slug',
  },
};
